import { render, staticRenderFns } from "./MpPuzzleV2.vue?vue&type=template&id=06882811&scoped=true&"
import script from "./MpPuzzleV2.vue?vue&type=script&lang=js&"
export * from "./MpPuzzleV2.vue?vue&type=script&lang=js&"
import style1 from "./MpPuzzleV2.vue?vue&type=style&index=1&id=06882811&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06882811",
  null
  
)

export default component.exports